import { Space } from "antd";

interface Props {
  title: string;
  subtitle?: string;
  right?: React.ReactNode;
}

export function PageHeader({ title, subtitle, right }: Props) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24, gap: 16 }}>
      <div>
        <h1 style={{ fontSize: 22, fontWeight: 700, letterSpacing: "-0.02em", margin: 0, color: "var(--text-primary)" }}>
          {title}
        </h1>
        {subtitle && (
          <div style={{ fontSize: 14, color: "var(--text-secondary)", marginTop: 4 }}>{subtitle}</div>
        )}
      </div>
      {right && <Space style={{ flexShrink: 0 }}>{right}</Space>}
    </div>
  );
}
